import script from "./ViewSlot.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewSlot.vue?vue&type=script&setup=true&lang=js"

import "./ViewSlot.vue?vue&type=style&index=0&id=11f7b2ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11f7b2ec"]])

export default __exports__